module.exports = __webpack_public_path__ + "media/42.e1a4fbb5.mp3";